import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useAuth from "../../hooks/useAuth";
import InputUserinfo from "../../components/InputUserInfo/InputUserInfo";
import Userinfo from "../../components/UserInfo/UserInfo";
import CardLoadingPage from "../../components/CardLoadingPage/CardLoadingPage";
import useMediaQuery from "../../hooks/useMediaQuery";
import { setLoggedUser } from "../../store/actions/user";

const UserinfoPage = () => {
  const userData = useSelector((state) => state.user.userData);
  const [isEditMode, setIsEditMode] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const isWideScreen = useMediaQuery("(min-width: 1200px)");
  const isMax500px = useMediaQuery("(max-width: 500px)");
  const dispatch = useDispatch();
  const editMode = () => {
    setIsEditMode(true);
  };

  useEffect(() => {
    setCollapsed(!isWideScreen);
  }, [isWideScreen]);

  const handleSaveUserInfo = (formData) => {
    dispatch(setLoggedUser(formData));
  };

  return (
    <>
      {userData ? (
        <div className={`card custom-card w-100 shadow`}>
          <div className={`${isMax500px ? "py-4 px-1" : "p-5"}`}>
            <div className="container">
              <div className="d-flex justify-content-between mb-5 custom-card-header">
                <div className="d-flex gap-3 custom-card-header my-2">
                  <div className={`custom-icon-container`}>
                    <i className={`bi custom-icon bi-person fs-1`}></i>
                  </div>
                  <div>
                    <span className="fs-4 d-block">
                      {userData?.nome} {userData?.cognome} <span className="text-muted small">({userData?.tipo_utente === "course_designer" ? "course designer" : userData?.tipo_utente})</span>
                    </span>
                    <span className="text-muted">{userData?.username}</span>
                  </div>
                </div>
                <div className="my-2 align-self-center">
                  <button className="btn btn-primary" onClick={editMode}>
                    Modifica
                  </button>
                </div>
              </div>
              {isEditMode ? (
                <InputUserinfo
                  userData={userData}
                  isEditMode={isEditMode}
                  setIsEditMode={setIsEditMode}
                  onSaveUserInfo={handleSaveUserInfo}
                />
              ) : (
                <Userinfo userData={userData} />
              )}
            </div>
          </div>
        </div>
      ) : (
        <CardLoadingPage />
      )}
    </>
  );
};

export default UserinfoPage;
